
import { ApiRoutes } from "lib/services/api.routes";
import { NewApiService } from "lib/services/api/newapi.service";
import { Observable } from "rxjs";
import { AjaxError, AjaxResponse } from "rxjs/ajax";
import { ILoginDispatch, ILoginReponse, IReduxDispatchable, KeyType } from "../interfaces/login.interface";

export class LoginService {
    _apiService: NewApiService;
    /**
     *
     */
    constructor() {
        this._apiService = new NewApiService();
        this._apiService.setOptions({ handleErrors: false });

    }
    public DetermineKeyPressed(key: string, keyType: KeyType): boolean {
        switch (keyType) {
            case KeyType.Enter:
                return ((key === "Enter") || (key === "NumpadEnter"));
            default:
                return false;
        }
    }

    public Login(username: string, password: string): Observable<AjaxResponse<any>> {
        return this._apiService.post<any>({
            url: ApiRoutes.LoginPage.UserLogin,
            data: {
                email: username,
                password: password
            },
            params: {},
            isAuthenticated: false
        })
    }


    public GetUserFromUsername(username: string): Observable<AjaxResponse<any>> {
        return this._apiService.get<any>({
            url: ApiRoutes.LoginPage.GetNameFromUsername,
            params: { username },
            isAuthenticated: false
        })
    }

    public GetUserFromEncryptedPqp(encrypted: string) : Observable<AjaxResponse<any>> {
      return this._apiService.post<any>({
        url: ApiRoutes.LoginPage.LoginWithKey,
        data: {
          EncryptedPqp: encrypted
        },
        isAuthenticated: false
      });
    }

    public DispatchLogin(loginData: ILoginReponse): IReduxDispatchable<ILoginDispatch> {
        return {
            type: "user/logIn",
            payload: {
                id: loginData.user.UserID,
                type: loginData.UserType,
                role: loginData.RoleId,
                roleName: loginData.Roles ? loginData.Roles[0] : undefined,
                participantId: loginData.user.ParticipantID,
                participantLanguageId: loginData.user.ParticipantCultureId,
                username: loginData.Username,
                firstName: loginData.FirstName,
                lastName: loginData.LastName,
                fullName: loginData.FirstName + " " + loginData.LastName,
                languageId: loginData.CultureId,
                user_token: loginData.user.user_token,
                email: loginData.Email,
                redirect: {
                  assessmentRedirect: loginData.user.PQPId,
                  submitRedirect: loginData.user.RedirectUrl
                },
               unknownParticipant: loginData.UnknownParticipant
            },
        };
    }

    public BuildMessage(error: AjaxError) {
        if (!error.response || !error.response.reason_code)
            return `Invalid Username/Password`;

        switch (error.response.reason_code) {
            case 0:
                return `Invalid Username/Password`;
            case 1:
                return "Account Locked";
            case 2:
                return "Accound Disabled";
        }
    }

     GetUserProfile(UserId: number, UserType: number) {
        return this._apiService.get<any>({
            url: ApiRoutes.Profile.GetUserProfile,
            params: {
                UserId,
                UserType
            },
            isAuthenticated: false
        })
    }

}
